import React, { useId } from 'react';
import Button from 'react-bootstrap/Button';
import { Icon } from '@fikasio/react-ui-components';
import { useTranslation } from 'react-i18next';
import { Tooltip } from 'react-tooltip';
import styles from './FilterButton.module.css';

interface FilterButtonProps {
  activeCount?: number;
  isOpen?: boolean;
  onClick?: () => void;
}

const FilterButton = ({
  activeCount = 0,
  isOpen = false,
  onClick,
}: FilterButtonProps) => {
  const { t } = useTranslation();
  const tooltipId = `filters-${useId().replace(/:/g, '')}`;
  const label = activeCount > 0
    ? t('activeFilters', { count: activeCount })
    : t('filters');

  return (
    <>
      <Button
        aria-expanded={isOpen}
        aria-label={label}
        className={styles.button}
        data-testid="filters-button"
        data-tooltip-content={label}
        data-tooltip-id={tooltipId}
        onClick={onClick}
        variant="light"
      >
        <Icon
          name="sliders"
          size="1x"
        />
        {
          activeCount > 0 && (
            <span className={styles.badge}>
              {activeCount}
            </span>
          )
        }
      </Button>
      <Tooltip id={tooltipId} />
    </>
  );
};

export default FilterButton;
